import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

import Message from '../base/Message.vue';
import { useAutoAnimate } from '@formkit/auto-animate/vue';
import { useNotificationStore } from '~src/admin/stores/useNotificationStore';

// Get the messages from the store

export default /*@__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const { messages } = useNotificationStore();

// Animation of notifiactions
const [notifiactionsWrapper] = useAutoAnimate({ duration: 300, easing: 'ease-in-out' });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(messages).length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "flex flex-col gap-3 fixed top-12 right-12 z-20",
            ref_key: "notifiactionsWrapper",
            ref: notifiactionsWrapper
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (message, i) => {
              return (_openBlock(), _createBlock(Message, {
                class: "min-w-[150px] shadow-md",
                key: i,
                message: message.message,
                type: message.type,
                link: message.link,
                "show-icon": true,
                size: "large"
              }, null, 8, ["message", "type", "link"]))
            }), 128))
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})